import img from "../../assets/images/common/1dfc38db6aed9cbac4a39ad4b02302ac.jpg";

const reportsData = [
  {
    image: img,
    title: "Global Cardiac Rhythm Management Devices Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The Global Cardiac Rhythm Management (CRM) Devices Market is projected to grow from USD 23.87 billion in 2025 to approximately USD 40.94 billion by 2034, at a CAGR of 6.18%. North America accounted for USD 10.34 billion in 2024 and is set to expand at a CAGR of 6.30% during the forecast period. In the U.S., the market is expected to increase from USD 8 billion in 2025 to USD 13 billion by 2034, registering a CAGR of 5.56%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1286",
    publishDate: "April, 2025",
    category: "Life Sciences",
    pages: "210",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Electric Vehicle Charger Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The Electric Vehicle Charger Market is projected to grow from USD 17.67 billion in 2025 to approximately USD 168.7 billion by 2034, at a CAGR of 28.49%. Asia Pacific accounted for USD 6.7 billion in 2024 and is set to expand at a CAGR of 27.7% during the forecast period. In the China Electric Vehicle Charger Market, the market is expected to increase from USD 4 billion in 2025 to USD 35 billion by 2034, registering a CAGR of 5.56%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "A1736",
    publishDate: "April, 2025",
    category: "Consumer Goods",
    pages: "237",
    price: "$3999",
  },

  {
    image: img,
    title: "Global 5G In Healthcare Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The 5G In Healthcare Market is projected to grow from USD 57.6 billion in 2025 to approximately USD 372.2 billion by 2034, at a CAGR of 23.04%. North America accounted for USD 20.7 billion in 2024 and is set to expand at a CAGR of 22.6% during the forecast period. In the U.S. 5G In Healthcare Market, the market is expected to increase from USD 18.4 billion in 2025 to USD 110 billion by 2034, registering a CAGR of 21.9%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1576",
    publishDate: "Jan, 2025",
    category: "Materials and Chemicals",
    pages: "227",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Advanced Driver Assistance Systems Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The Advanced Driver Assistance Systems Market is projected to grow from USD 39.7 billion in 2025 to approximately USD 96.4 billion by 2034, at a CAGR of 10.3%. North America accounted for USD 12.3 billion in 2024 and is set to expand at a CAGR of 9.5% during the forecast period. In the U.S. Advanced Driver Assistance Systems Market, the market is expected to increase from USD 11.1 billion in 2025 to USD 24.6 billion by 2034, registering a CAGR of 9.1%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "A1671",
    publishDate: "Mar, 2025",
    category: "Construction and Manufacturing",
    pages: "237",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Artificial Intelligence in Transportation Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The Artificial Intelligence in Transportation Market is projected to grow from USD 3.9 billion in 2025 to approximately USD 28.4 billion by 2034, at a CAGR of 24.6%. North America accounted for USD 1.5 billion in 2024 and is set to expand at a CAGR of 23.9 % during the forecast period. In the U.S. Artificial Intelligence in Transportation Market, the market is expected to increase from USD 1.3 billion in 2025 to USD 9.2 billion by 2034, registering a CAGR of 23.6%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "I1437",
    publishDate: "Feb, 2025",
    category: "Food and Beverages",
    pages: "217",
    price: "$3999",
  },

  {
    image: img,
    title: "Global AI Data Center Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The AI Data Center Market is projected to grow from USD 14.8 billion in 2025 to approximately USD 143.3 billion by 2034, at a CAGR of 28.6%. North America accounted for USD 5.3 billion in 2024 and is set to expand at a CAGR of 27.8 % during the forecast period. In the U.S. AI Data Center Market, the market is expected to increase from USD 4.3 billion in 2025 to USD 38 billion by 2034, registering a CAGR of 27.8%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "I1274",
    publishDate: "March, 2025",
    category: "Energy and Power",
    pages: "224",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Food Beverage Metal Cans Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The Food Beverage Metal Cans Market is projected to grow from USD 51.3 billion in 2025 to approximately USD 93.4 billion by 2034, at a CAGR of 6.8%. North America accounted for USD 17.4 billion in 2024 and is set to expand at a CAGR of 6.1 % during the forecast period. In the U.S. Food Beverage Metal Cans Market, the market is expected to increase from USD 13.6 billion in 2025 to USD 22.7 billion by 2034, registering a CAGR of 5.8%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "P1270",
    publishDate: "Jan, 2025",
    category: "Semiconductor and Electronics",
    pages: "213",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Cold Storage Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The Cold Storage Market is projected to grow from USD 183.6 billion in 2025 to approximately USD 426.2 billion by 2034, at a CAGR of 9.8%. North America accounted for USD 64.8 billion in 2024 and is set to expand at a CAGR of 9.1 % during the forecast period. In the U.S. Cold Storage Market, the market is expected to increase from USD 55.7 billion in 2025 to USD 119.5 billion by 2034, registering a CAGR of 8.8%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "A1342",
    publishDate: "Mar, 2025",
    category: "Automotive and Transportation",
    pages: "231",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Organic Farming Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The Organic Farming Market is projected to grow from USD 198.2 billion in 2025 to approximately USD 482.2 billion by 2034, at a CAGR of 10.3%. Asia Pacific accounted for USD 54.1 billion in 2024 and is set to expand at a CAGR of 9.5 % during the forecast period. In the China Organic Farming Market, the market is expected to increase from USD 34 billion in 2025 to USD 74.71 billion by 2034, registering a CAGR of 9.1%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "C1451",
    publishDate: "April, 2025",
    category: "ICT and Media",
    pages: "218",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Semiconductor Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The Semiconductor Market is projected to grow from USD 540.3 billion in 2025 to approximately USD 1072.2 billion by 2034, at a CAGR of 5.7%. Asia Pacific accounted for USD 338.4 billion in 2024 and is set to expand at a CAGR of 5.3 % during the forecast period. In the China Semiconductor Market, the market is expected to increase from USD 226.7 billion in 2025 to USD 345.8 billion by 2034, registering a CAGR of 4.8%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "C1451",
    publishDate: "April, 2025",
    category: "Aerospace and Defense",
    pages: "218",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Biodegradable Packaging Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The Biodegradable Packaging Market is projected to grow from USD 486.64 billion in 2025 to approximately USD 918.31 billion by 2034, at a CAGR of 7.3%. The Asia Pacific accounted for USD 210.7 billion in 2024 and is expected to expand at a CAGR of 6.7% during the forecast period. In the China Biodegradable Packaging Market, the market is expected to increase from USD 134.8 billion in 2025 to USD 235.7 billion by 2034, registering a CAGR of 6.4%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "P1271",
    publishDate: "Mar, 2025",
    category: "BFSI",
    pages: "218",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Cell and Gene Therapy Market Size, Share, Trends, and Recent Initiative 2025 to 2034",
    info: "The Cell and Gene Therapy Market is projected to grow from USD 26.47 billion in 2025 to approximately USD 178.67 billion by 2034, at a CAGR of 23.6%. North America accounted for USD 13 billion in 2024 and is expected to expand at a CAGR of 23.1% during the forecast period. In the U.S. Cell and Gene Therapy Market, the market is expected to increase from USD 11.6 billion in 2025 to USD 73.6 billion by 2034, registering a CAGR of 22.7%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1316",
    publishDate: "Mar, 2025",
    category: "Life Sciences",
    pages: "231",
    price: "$3999",
  },

  {
    image: img,
    title: "Red Biotechnology Market Size, Share, and Trends 2025 to 2034",
    info: "The Red Biotechnology Market is projected to grow from USD 422.37 billion in 2025 to approximately USD 672.4 billion by 2034, at a CAGR of 5.30%. North America accounted for USD 163.3 billion in 2025 and is expected to expand at a CAGR of 4.47% during the forecast period. In the U.S. Red Biotechnology Market, the market is expected to increase from USD 150.26 billion in 2025 to USD 215.44 billion by 2034, registering a CAGR of 4.08%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1546",
    publishDate: "Mar, 2025",
    category: "Consumer Goods",
    pages: "216",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Commercial Display Market Size, Share, and Trends 2025 to 2034",
    info: "The Commercial Display Market is projected to grow from USD 63.14 billion in 2025 to approximately USD109.96 billion by 2034, at a CAGR of 6.36%. North America accounted for USD 21.43 billion in 2025 and is expected to expand at a CAGR of 5.29% during the forecast period. In the U.S. Commercial Display Market, the market is expected to increase from USD 19.50 billion in 2025 to USD 29.99 billion by 2034, registering a CAGR of 4.90%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "SE125",
    publishDate: "April, 2025",
    category: "Materials and Chemicals",
    pages: "215",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Biotechnology Reagents & Kits Market Size, Share and Trends 2025 to 2034",
    info: "The Biotechnology Reagents & Kits Market is projected to grow from USD 545.96 billion in 2025 to approximately USD 1442.56 billion by 2034, at a CAGR of 11.40%. North America accounted for USD 218.38 billion in 2025 and is expected to expand at a CAGR of 10.77% during the forecast period. In the U.S. Biotechnology Reagents & Kits Market, the market is expected to increase from USD 189.99 billion in 2025 to USD 465.94 billion by 2034, registering a CAGR of 10.48%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "BT125",
    publishDate: "April, 2025",
    category: "Construction and Manufacturing",
    pages: "225",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Pharmacovigilance Market Size, Share and Trends 2025 to 2034",
    info: "The Pharmacovigilance Market is projected to grow from USD 8.21 billion in 2025 to approximately USD 16.91 billion by 2034, at a CAGR of 8.36%. North America accounted for USD 2.55 billion in 2025 and is expected to expand at a CAGR of 7.51% during the forecast period. In the U.S. Pharmacovigilance Market, the market is expected to increase from USD 2.32 billion in 2025 to USD 4.36 billion by 2034, registering a CAGR of 7.34 %. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1345",
    publishDate: "April, 2025",
    category: "Food and Beverages",
    pages: "225",
    price: "$3999",
  },

  {
    image: img,
    title: "Mental Health Apps Market Size, Share and Trends 2025 to 2034",
    info: "The Mental Health Apps Market is projected to grow from USD 8.1 billion in 2025 to approximately USD 27.49 billion by 2034, at a CAGR of 14.54 %. North America accounted for USD 3.08 billion in 2025 and is expected to expand at a CAGR of 13.81% during the forecast period. In the U.S. Mental Health Apps Market, the market is expected to increase from USD 2.81 billion in 2025 to USD 8.80 billion by 2034, registering a CAGR of 13.53 %. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1345",
    publishDate: "April, 2025",
    category: "Energy and Power",
    pages: "235",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Plant-Based Food Market Size, Share and Trends 2025 to 2034",
    info: "The Global Plant-Based Food Market is projected to grow from USD 55.05 billion in 2025 to approximately USD 103.75 billion by 2034, at a CAGR of 7.30%. North America accounted for USD 11.56 billion in 2025 and is expected to expand at a CAGR of 6.11% during the forecast period. In the U.S. Global Plant-Based Food Market, the market is expected to increase from USD 10.98 billion in 2025 to USD 18.33 billion by 2034, registering a CAGR of 5.86%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "FB1465",
    publishDate: "April, 2025",
    category: "Semiconductor and Electronics",
    pages: "215",
    price: "$3999",
  },

  {
    image: img,
    title: "Global sleep monitoring devices market Size, Share and Trends 2025 to 2034",
    info: "The Global sleep monitoring devices market is projected to grow from USD 24.79 billion in 2025 to approximately USD 104.45 billion by 2034, at a CAGR of 17.33%. North America accounted for USD 10.57 billion in 2025 and is expected to expand at a CAGR of 16.50% during the forecast period. In the U.S. Global sleep monitoring devices market, the market is expected to increase from USD 9.72 billion in 2025 to USD 37.602 billion by 2034, registering a CAGR of 16.21%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1565",
    publishDate: "April, 2025",
    category: "Automotive and Transportation",
    pages: "227",
    price: "$3999",
  },

  {
    image: img,
    title: "Global Dietary Supplements Market Size, Share and Trends 2025 to 2034",
    info: "The Dietary Supplements Market is projected to grow from USD 197 billion in 2025 to approximately USD 397.25 billion by 2034, at a CAGR of 8.10%. Asia Pacific accounted for USD 74.58 billion in 2025 and is set to expand at a CAGR of 7.17 % during the forecast period. In the China Dietary Supplements Market, the market is expected to increase from USD 81.95 billion in 2025 to USD 154.92 billion by 2034, registering a CAGR of 7.33%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "FB1535",
    publishDate: "May, 2025",
    category: "ICT and Media",
    pages: "216",
    price: "$3999",
  },

  {
    image: img,
    title: "Personalized Nutrition Market Size, Share and Trends 2025 to 2034",
    info: "The Personalized Nutrition Market is projected to grow from USD 17.55 billion in 2025 to approximately USD 63.82 billion by 2034, at a CAGR of 15.42%. North America accounted for USD 7.54 billion in 2025 and is expected to expand at a CAGR of 14.82% during the forecast period. In the U.S. Personalized Nutrition Market, the market is expected to increase from USD 6.94 billion in 2025 to USD 23.54 billion by 2034, registering a CAGR of 14.54%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "FB1355",
    publishDate: "May, 2025",
    category: "Aerospace and Defense",
    pages: "220",
    price: "$3999",
  },

  {
    image: img,
    title: "Health Coach Market Size, Share, and Trends 2025 to 2034",
    info: "The Health Coach Market is projected to grow from USD 19.05 billion in 2025 to approximately USD 37.40 billion by 2034, at a CAGR of 7.78%. North America accounted for USD 7.62 billion in 2025 and is expected to expand at a CAGR of 8.37% during the forecast period. In the U.SHealth Coach Market, the market is expected to increase from USD 7.01 billion in 2025 to USD 14.13 billion by 2034, registering a CAGR of 8.11%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year. ",
    reportCode: "H1554",
    publishDate: "May, 2025",
    category: "BFSI",
    pages: "222",
    price: "$3999",
  },

  {
    image: img,
    title: "Artificial Intelligence In Retail Market Size, Share, and Trends 2025 to 2034",
    info: "The Artificial Intelligence In Retail Market is projected to grow from USD 14.13 billion in 2025 to approximately USD 67.75 billion by 2034, at a CAGR of 19.03%. North America accounted for USD 5.65 billion in 2025 and is expected to expand at a CAGR of 18.35 % during the forecast period. In the U.S Artificial Intelligence In Retail Market, the market is expected to increase from USD 5.19 billion in 2025 to USD 23.17 billion by 2034, registering a CAGR of 18.06%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "ICT1554",
    publishDate: "May, 2025",
    category: "Life Sciences",
    pages: "235",
    price: "$3999",
  },

  {
    image: img,
    title: "Smart Warehouse Market Size, Share and Trends 2025 to 2034",
    info: "The Smart Warehouse Market is projected to grow from USD 24.51 billion in 2025 to approximately USD 81.34 billion by 2034, at a CAGR of 14.26%. North America accounted for USD 7.84 billion in 2025 and is expected to expand at a CAGR of 13.44 % during the forecast period. In the U.S Smart Warehouse Market, the market is expected to increase from USD 7.05 billion in 2025 to USD 21.47billion by 2034, registering a CAGR of 13.16%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year. ",
    reportCode: "ICT1554",
    publishDate: "May, 2025",
    category: "Energy and Power",
    pages: "237",
    price: "$3999",
  },

  {
    image: img,
    title: "Viral Vectors & Plasmid DNA Manufacturing Market Size, Share and Trends 2025 to 2034",
    info: "The Global Viral Vectors & Plasmid DNA Manufacturing Market is projected to grow from USD 7.13 billion in 2025 to approximately USD 23.15 billion by 2034, at a CAGR of 13.98%. The North America accounted for USD 3.493 billion in 2025 and is expected to expand at a CAGR of 13.45 % during the forecast period. In the U.S Viral Vectors & Plasmid DNA Manufacturing Market, the market is expected to increase from USD 3.179 billion in 2025 to USD 9.68 billion by 2034, registering a CAGR of 13.17%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H4673",
    publishDate: "June, 2025",
    category: "Life Sciences",
    pages: "235",
    price: "$3999",
  },

  {
    image: img,
    title: "Business-to-Business E-commerce  Market Size, Share and Trends 2025 to 2034",
    info: "The Global Business-to-Business E-commerce Market  is projected to grow from USD 13.2 Trillion in 2025 to approximately USD 65.55 Trillion by 2034, at a CAGR of 19.49%. The North America accounted for USD 5.148 Trillion in 2025 and is expected to expand at a CAGR of 18.79 % during the forecast period. In the U.S Business-to-Business E-commerce Market, the market is expected to increase from USD 4.6 Trillion in 2025 to USD 21.58 Trillion by 2034, registering a CAGR of 18.50%. All figures are revenue-based (USD Million/Trillion), with 2024 as the base year.",
    reportCode: "H7792",
    publishDate: "April, 2025",
    category: "ICT and Media",
    pages: "240",
    price: "$4299",
  },

  {
    image: img,
    title: "Digital Therapeutics Market Size, Share and Trends 2025 to 2034",
    info: "The Global Digital Therapeutics Market is projected to grow from USD 8.25 billion in 2025 to approximately USD 45 billion by 2034, at a CAGR of 20.74%. The North America accounted for USD 3.54 billion in 2025 and is expected to expand at a CAGR of 20.11% during the forecast period. In the U.S Digital Therapeutics Market, the market is expected to increase from USD 3.29 billion in 2025 to USD 16.78 billion by 2034, registering a CAGR of 19.82%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H4282",
    publishDate: "May, 2025",
    category: "Life Sciences",
    pages: "248",
    price: "$3999",
  },

  {
    image: img,
    title: "Smart insulin pens market Size, Share and Trends 2025 to 2034",
    info: "The Global Smart insulin pens market  is projected to grow from USD 181.75 billion in 2025 to approximately USD 895 billion by 2034, at a CAGR of 19.38 %. The Europe accounted for USD 76.335 billion in 2025 and is expected to expand at a CAGR of 19.06% during the forecast period. In the Germany Smart insulin pens market, the market is expected to increase from USD 68.70 billion in 2025 to USD 322.91 billion by 2034, registering a CAGR of 18.76%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6219",
    publishDate: "June, 2025",
    category: "Life Sciences",
    pages: "234",
    price: "$3499",
  },

  {
    image: img,
    title: "Sports app market Size, Share and Trends 2025 to 2034",
    info: "The GlobalSports app market is projected to grow from USD 5.65 billion in 2025 to approximately USD 14.55 billion by 2034, at a CAGR of 11.08%. The North America accounted for USD 2.05 billion in 2025 and is expected to expand at a CAGR of 10.40% during the forecast period. In the U.S Sports app market, the market is expected to increase from USD 1.95 billion in 2025 to USD 4.65 billion by 2034, registering a CAGR of 10.13%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H8329",
    publishDate: "May, 2025",
    category: "Consumer Goods",
    pages: "244",
    price: "$3499",
  },

  {
    image: img,
    title: "Pet Wearable Market Size, Share and Trends 2025 to 2034",
    info: "The Global Pet Wearable Market is projected to grow from USD 7.8 billion in 2025 to approximately USD 25.60 billion by 2034, at a CAGR of 14.12%. The North America accounted for USD 2.964 billion in 2025 and is expected to expand at a CAGR of 13.43% during the forecast period. In the U.S Pet Wearable Market, the market is expected to increase from USD 2.72 billion in 2025 to USD 8.29 billion by 2034, registering a CAGR of 13.16%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H2627",
    publishDate: "July, 2025",
    category: "Consumer Goods",
    pages: "247",
    price: "$4299",
  },

  {
    image: img,
    title: "Food Traceability Tech market Size, Share and Trends 2025 to 2034",
    info: "The Global Food Traceability Tech market is projected to grow from USD 2.25 billion in 2025 to approximately USD 40.75 billion by 2034, at a CAGR of 8.08%. The North America accounted for USD 6.275 billion in 2025 and is expected to expand at a CAGR of  7.28% during the forecast period. In the U.S Food Traceability Tech market, the market is expected to increase from USD 5.965 billion in 2025 to USD 10.87 billion by 2034, registering a CAGR of  6.90%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1882",
    publishDate: "July, 2025",
    category: "Food and Beverages",
    pages: "234",
    price: "$4299",
  },

  {
    image: img,
    title: "Biodegradable Plastics market Size, Share and Trends 2025 to 2034",
    info: "The Global Biodegradable Plastics market is projected to grow from USD 5.25 billion in 2025 to approximately USD 13.35 billion by 2034, at a CAGR of 10.93%. The Europe accounted for USD 2.205 billion in 2025 and is expected to expand at a CAGR of 10.63% during the forecast period. In the Germany Biodegradable Plastics market, the market is expected to increase from USD 1.98 billion in 2025 to USD 4.81 billion by 2034, registering a CAGR of 10.35%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H3125",
    publishDate: "July, 2025",
    category: "Materials and Chemicals",
    pages: "244",
    price: "$3999",
  },

  {
    image: img,
    title: "Algae Biofuel Market market Size, Share and Trends 2025 to 2034",
    info: "The Global  Algae Biofuel Market is projected to grow from USD 11.05 billion in 2025 to approximately USD 27.65 billion by 2034, at a CAGR of 10.49%. The North America accounted for USD 4.51 billion in 2025 and is expected to expand at a CAGR of 10.53% during the forecast period. In the U.S Algae Biofuel Market, the market is expected to increase from USD 4.28 billion in 2025 to USD 9.6 billion by 2034, registering a CAGR of  9.49%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6299",
    publishDate: "April, 2025",
    category: "Materials and Chemicals",
    pages: "248",
    price: "$3799",
  },

  {
    image: img,
    title: "Low Foam Surfactants Market Size, Share and Trends 2025 to 2034",
    info: "The Global Low Foam Surfactants Market is projected to grow from USD 16.5 billion in 2025 to approximately USD 26.25 billion by 2034, at a CAGR of 5.29%. Asia Pacific accounted for USD 7.26 billion in 2025 and is set to expand at a CAGR of 4.75% during the forecast period. In the China Low Foam Surfactants Market, the market is expected to increase from USD 6.89 billion in 2025 to USD 10.25 billion by 2034, registering a CAGR of 4.50%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6421",
    publishDate: "July, 2025",
    category: "Materials and Chemicals",
    pages: "236",
    price: "$4299",
  },

  {
    image: img,
    title: "Green Building Materials Market Size, Share and Trends 2025 to 2034",
    info: "The Global Green Building Materials Market  is projected to grow from USD 422.02 billion in 2025 to approximately USD 1069 billion by 2034, at a CAGR of 10.88%. The North America accounted for USD 147.70 billion in 2025 and is expected to expand at a CAGR of 10.16% during the forecast period. In the U.S Green Building Materials Market, the market is expected to increase from USD 135.89 billion in 2025 to USD 317.49 billion by 2034, registering a CAGR of  9.89%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H3885",
    publishDate: "June, 2025",
    category: "Construction and Manufacturing",
    pages: "232",
    price: "$3999",
  },

  {
    image: img,
    title: "Small Modular Reactor (SMR) Market Size, Share and Trends 2025 to 2034",
    info: "The Global Small Modular Reactor (SMR) Market is projected to grow from USD 9.28 billion in 2025 to approximately USD 57.98 billion by 2034, at a CAGR of 22.58%. Asia Pacific accounted for USD 7.424 billion in 2025 and is set to expand at a CAGR of 22.23% during the forecast period. In the China Small Modular Reactor (SMR) Market, the market is expected to increase from USD 7.05 billion in 2025 to USD 42.5 billion by 2034, registering a CAGR of 21.95%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H7777",
    publishDate: "June, 2025",
    category: "Energy and Power",
    pages: "240",
    price: "$3999",
  },

  {
    image: img,
    title: "Solid State Batteries Market Size, Share and Trends 2025 to 2034",
    info: "The Global Solid State Batteries Market is projected to grow from USD 1.54 billion in 2025 to approximately USD 22.05 billion by 2034, at a CAGR of 34.41%. Asia Pacific accounted for USD 0.83 billion in 2025 and is set to expand at a CAGR of 33.85% during the forecast period. In the China Solid State Batteries Market, the market is expected to increase from USD 0.79 billion in 2025 to USD 10.66 billion by 2034, registering a CAGR of 33.53%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6565",
    publishDate: "April, 2025",
    category: "Construction and Manufacturing",
    pages: "241",
    price: "$4299",
  },

  {
    image: img,
    title: "Green Data Centers Market Size, Share and Trends 2025 to 2034",
    info: "The Global Green Data Centers Market is projected to grow from USD 84.46 billion in 2025 to approximately USD 404.02 billion by 2034, at a CAGR of 18.99%. The North America accounted for USD 32.93 billion in 2025 and is expected to expand at a CAGR of 18.30% during the forecast period. In the U.S Green Data Centers Market, the market is expected to increase from USD 30.30 billion in 2025 to USD 134.53 billion by 2034, registering a CAGR of 18.01%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H7484",
    publishDate: "July, 2025",
    category: "Construction and Manufacturing",
    pages: "232",
    price: "$3799",
  },

  {
    image: img,
    title: "Meat Products Market Size, Share and Trends 2025 to 2034",
    info: "The Global Meat Products Market is projected to grow from USD 1825.65 billion in 2025 to approximately USD 2735.55 billion by 2034, at a CAGR of 4.60%. Asia Pacific accounted for USD 821.54 billion in 2025 and is set to expand at a CAGR of 4.07% during the forecast period. In the China Meat Products Market, the market is expected to increase from USD 780.46 billion in 2025 to USD 1093.94 billion by 2034, registering a CAGR of 3.82%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6970",
    publishDate: "July, 2025",
    category: "Food and Beverages",
    pages: "246",
    price: "$4299",
  },

  {
    image: img,
    title: "Processed Meat Market Size, Share and Trends 2025 to 2034",
    info: "The Global Processed Meat Market is projected to grow from USD 744.32 billion in 2025 to approximately USD 1264.54 billion by 2034, at a CAGR of 6.07%. The North America accounted for USD 364.71 billion in 2025 and is expected to expand at a CAGR of 5.58% during the forecast period. In the U.S Processed Meat Market, the market is expected to increase from USD 335.53 billion in 2025 to USD 534.90 billion by 2034, registering a CAGR of 5.32%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H8638",
    publishDate: "April, 2025",
    category: "Food and Beverages",
    pages: "234",
    price: "$3799",
  },

  {
    image: img,
    title: "EV Battery Recycling Market  Size, Share and Trends 2025 to 2034",
    info: "The Global EV Battery Recycling Market is projected to grow from USD 31.95 billion in 2025 to approximately USD 76.53 billion by 2034, at a CAGR of 10.19%. Asia Pacific accounted for USD 14.697 billion in 2025 and is set to expand at a CAGR of 9.65% during the forecast period. In the China EV Battery Recycling Market, the market is expected to increase from USD 13.96 billion in 2025 to USD 31.31 billion by 2034, registering a CAGR of 9.39%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1280",
    publishDate: "May, 2025",
    category: "Energy and Power",
    pages: "234",
    price: "$3499",
  },

  {
    image: img,
    title: "Solar Energy Market Size, Share and Trends 2025 to 2034",
    info: "The Global Solar Energy Market is projected to grow from USD 283.07 billion in 2025 to approximately USD 1054.70 billion by 2034, at a CAGR of 15.74%. Asia Pacific accounted for USD 167.01 billion in 2025 and is set to expand at a CAGR of 15.29% during the forecast period. In the China Solar Energy Market, the market is expected to increase from USD 158.66 billion in 2025 to USD 559.09 billion by 2034, registering a CAGR of 15.02%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6062",
    publishDate: "April, 2025",
    category: "Energy and Power",
    pages: "237",
    price: "$4299",
  },


  {
    image: img,
    title: "Thermostat Market  Size, Share and Trends 2025 to 2034",
    info: "The Global Thermostat Market  is projected to grow from USD 6.32 billion in 2025 to approximately USD 19.06 billion by 2034, at a CAGR of 13.05%. The North America accounted for USD 2.40 billion in 2025 and is expected to expand at a CAGR of 12.37% during the forecast period. In the U.S Thermostat Market , the market is expected to increase from USD 2.16 billion in 2025 to USD 6.03 billion by 2034, registering a CAGR of 12.09%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H9859",
    publishDate: "April, 2025",
    category: "Energy and Power",
    pages: "239",
    price: "$3499",
  },

  {
    image: img,
    title: "Thermostat Market  Size, Share and Trends 2025 to 2034",
    info: "The Global Smart Thermostat Market  is projected to grow from USD 2.41 billion in 2025 to approximately USD 9.24 billion by 2034, at a CAGR of 16.10%. The North America accounted for USD 0.84 billion in 2025 and is expected to expand at a CAGR of 15.35% during the forecast period. In the U.S Smart Thermostat Market , the market is expected to increase from USD 0.78 billion in 2025 to USD 2.77 billion by 2034, registering a CAGR of 15.07%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H3043",
    publishDate: "May, 2025",
    category: "Semiconductor and Electronics",
    pages: "250",
    price: "$3499",
  },

  {
    image: img,
    title: "Wireless Sensor Network Market Size, Share and Trends 2025 to 2034",
    info: "The Global Wireless Sensor Network Market is projected to grow from USD 30.4 billion in 2025 to approximately USD 153.35 billion by 2034, at a CAGR of 19.70%. The North America accounted for USD 11.85 billion in 2025 and is expected to expand at a CAGR of 19% during the forecast period. In the U.S Wireless Sensor Network Market, the market is expected to increase from USD 10.67 billion in 2025 to USD 49.93 billion by 2034, registering a CAGR of 18.70%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H4821",
    publishDate: "May, 2025",
    category: "Semiconductor and Electronics",
    pages: "247",
    price: "$3999",
  },

  {
    image: img,
    title: "Environmental Test Chambers Market Size, Share and Trends 2025 to 2034",
    info: "The Global Environmental Test Chambers Market is projected to grow from USD 1.11 billion in 2025 to approximately USD 1.45 billion by 2034, at a CAGR of 3.01%. Asia Pacific accounted for USD 0.455 billion in 2025 and is set to expand at a CAGR of 2.44% during the forecast period. In the China Environmental Test Chambers Market, the market is expected to increase from USD 0.435 billion in 2025 to USD 0.525 billion by 2034, registering a CAGR of 2.20%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H3952",
    publishDate: "June, 2025",
    category: "Semiconductor and Electronics",
    pages: "238",
    price: "$3999",
  },

  {
    image: img,
    title: "Autonomous Last Mile Delivery Market Size, Share and Trends 2025 to 2034",
    info: "The Global Autonomous Last Mile Delivery Market is projected to grow from USD 7.1 billion in 2025 to approximately USD 45.75 billion by 2034, at a CAGR of 23.0%. The North America accounted for USD 3.33 billion in 2025 and is expected to expand at a CAGR of 22.41% during the forecast period. In the U.S Autonomous Last Mile Delivery Market, the market is expected to increase from USD 3.03 billion in 2025 to USD 18.11 billion by 2034, registering a CAGR of 22.10%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H7640",
    publishDate: "April, 2025",
    category: "Automotive and Transportation",
    pages: "242",
    price: "$3999",
  },

  {
    image: img,
    title: "Urban Air Mobility (eVTOL) Market Size, Share and Trends 2025 to 2034",
    info: "The Global Urban air mobility (eVTOL) market is projected to grow from USD 5.72 billion in 2025 to approximately USD 54.73 billion by 2034, at a CAGR of 28.52%. The North America accounted for USD 2.28 billion in 2025 and is expected to expand at a CAGR of 27.79% during the forecast period. In the U.S Urban air mobility (eVTOL) market, the market is expected to increase from USD 2.05 billion in 2025 to USD 18.30 billion by 2034, registering a CAGR of 27.47%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H9217",
    publishDate: "July, 2025",
    category: "Automotive and Transportation",
    pages: "249",
    price: "$3999",
  },

  {
    image: img,
    title: "Electric Aircraft Market Size, Share and Trends 2025 to 2034",
    info: "The Global Electric Aircraft market is projected to grow from USD 15.39 billion in 2025 to approximately USD 51.41 billion by 2034, at a CAGR of 14.34%. The North America accounted for USD 6.87 billion in 2025 and is expected to expand at a CAGR of 13.55% during the forecast period. In the U.S Electric Aircraft market, the market is expected to increase from USD 6.32 billion in 2025 to USD 19.43 billion by 2034, registering a CAGR of 13.27%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H3028",
    publishDate: "June, 2025",
    category: "Automotive and Transportation",
    pages: "231",
    price: "$3999",
  },

  {
    image: img,
    title: "Cyber Security Market Size, Share and Trends 2025 to 2034",
    info: "The Global Cyber security Market is projected to grow from USD 249.41 billion in 2025 to approximately USD 767.55 billion by 2034, at a CAGR of 13.30%. The North America accounted for USD 84.799 billion in 2025 and is expected to expand at a CAGR of 12.54% during the forecast period. In the U.S Cyber security Market, the market is expected to increase from USD 78.01 billion in 2025 to USD 221.05 billion by 2034, registering a CAGR of 12.27%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6579",
    publishDate: "May, 2025",
    category: "ICT and Media",
    pages: "236",
    price: "$3999",
  },

  {
    image: img,
    title: "Electric Vehicle Sound Generator Market Size, Share and Trends 2025 to 2034",
    info: "The Global Electric Vehicle Sound Generator Market is projected to grow from USD 1.73 billion in 2025 to approximately USD 4.09 billion by 2034, at a CAGR of 10.03%. Asia Pacific accounted for USD 0.692 billion in 2025 and is set to expand at a CAGR of 9.41% during the forecast period. In the China Electric Vehicle Sound Generator Market, the market is expected to increase from USD 0.657 billion in 2025 to USD 1.44 billion by 2034, registering a CAGR of 9.15%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H8854",
    publishDate: "April, 2025",
    category: "Automotive and Transportation",
    pages: "241",
    price: "$3999",
  },

  {
    image: img,
    title: "Agricultural Drones Market Size, Share and Trends 2025 to 2034",
    info: "The Global Agricultural Drones Market is projected to grow from USD 2.46 billion in 2025 to approximately USD 14.75 billion by 2034, at a CAGR of 21.07%. The North America accounted for USD 1.03 billion in 2025 and is expected to expand at a CAGR of 20.34% during the forecast period. In the U.S Agricultural Drones Market, the market is expected to increase from USD 0.922 billion in 2025 to USD 4.77 billion by 2034, registering a CAGR of 20%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1105",
    publishDate: "July, 2025",
    category: "ICT and Media",
    pages: "239",
    price: "$3999",
  },

  {
    image: img,
    title: "Smart Home Market Size, Share and Trends 2025 to 2034",
    info: "The Global Smart Home Market is projected to grow from USD 162.39 billion in 2025 to approximately USD 1384.14 billion by 2034, at a CAGR of 26.88%. The North America accounted for USD 56.83 billion in 2025 and is expected to expand at a CAGR of 26.06% during the forecast period. In the U.S Smart Home Market, the market is expected to increase from USD 52.28 billion in 2025 to USD 411.08 billion by 2034, registering a CAGR of 25.75%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H7623",
    publishDate: "June, 2025",
    category: "ICT and Media",
    pages: "243",
    price: "$3999",
  },

  {
    image: img,
    title: "Smart Agriculture Market Size, Share and Trends 2025 to 2034",
    info: "The Global Smart Agriculture market is projected to grow from USD 27.58 billion in 2025 to approximately USD 82.74 billion by 2034, at a CAGR of 12.98%. The North America accounted for USD 11.85 billion in 2025 and is expected to expand at a CAGR of 12.39% during the forecast period. In the U.S Smart Agriculture market, the market is expected to increase from USD 11.02 billion in 2025 to USD 30.87 billion by 2034, registering a CAGR of 12.12%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H9234",
    publishDate: "April, 2025",
    category: "ICT and Media",
    pages: "232",
    price: "$3999",
  },

  {
    image: img,
    title: "Silver Nanoparticles Market Size, Share and Trends 2025 to 2034",
    info: "The Global Silver Nanoparticles Market is projected to grow from USD 3.06 billion in 2025 to approximately USD 6.03 billion by 2034, at a CAGR of 7.83%. The North America accounted for USD 2.01 billion in 2025 and is expected to expand at a CAGR of 7.46% during the forecast period. In the U.S Silver Nanoparticles Market, the market is expected to increase from USD 1.91 billion in 2025 to USD 3.58 billion by 2034, registering a CAGR of 7.21%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H5046",
    publishDate: "June, 2025",
    category: "Materials and Chemicals",
    pages: "243",
    price: "$3999",
  },

  {
    image: img,
    title: "Aerospace Composites Market Size, Share and Trends 2025 to 2034",
    info: "The Global Aerospace Composites Market is projected to grow from USD 40.78 billion in 2025 to approximately USD 107.65 billion by 2034, at a CAGR of 11.39%. The North America accounted for USD 15.49 billion in 2025 and is expected to expand at a CAGR of 10.72% during the forecast period. In the U.S Aerospace Composites Market, the market is expected to increase from USD 14.41 billion in 2025 to USD 35.26 billion by 2034, registering a CAGR of 10.45%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H9273",
    publishDate: "April, 2025",
    category: "Aerospace and Defense",
    pages: "235",
    price: "$3999",
  },

  {
    image: img,
    title: "Space Tourism Market Size, Share and Trends 2025 to 2034",
    info: "The Global Space Tourism market is projected to grow from USD 1.61 billion in 2025 to approximately USD 5.70 billion by 2034, at a CAGR of 15.08%. The North America accounted for USD 0.644 billion in 2025 and is expected to expand at a CAGR of 14.43% during the forecast period. In the U.S Space Tourism market, the market is expected to increase from USD 0.59 billion in 2025 to USD 1.97 billion by 2034, registering a CAGR of 14.15%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H2456",
    publishDate: "July, 2025",
    category: "Aerospace and Defense",
    pages: "245",
    price: "$3999",
  },

  {
    image: img,
    title: "Anti-Drone Systems Market Size, Share and Trends 2025 to 2034",
    info: "The Global Anti-Drone Systems market is projected to grow from USD 3.03 billion in 2025 to approximately USD 26.79 billion by 2034, at a CAGR of 27.40%. The North America accounted for USD 1.39 billion in 2025 and is expected to expand at a CAGR of 26.77% during the forecast period. In the U.S Anti-Drone Systems market, the market is expected to increase from USD 1.29 billion in 2025 to USD 10.72 billion by 2034, registering a CAGR of 26.47%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H3504",
    publishDate: "July, 2025",
    category: "Aerospace and Defense",
    pages: "231",
    price: "$3999",
  },

  {
    image: img,
    title: "Quantum Cryptography Market Size, Share and Trends 2025 to 2034",
    info: "The Global Quantum Cryptography market is projected to grow from USD 0.98 billion in 2025 to approximately USD 8.40 billion by 2034, at a CAGR of 26.96%. The North America accounted for USD 0.38 billion in 2025 and is expected to expand at a CAGR of 26.22% during the forecast period. In the U.S Quantum Cryptography market, the market is expected to increase from USD 0.35 billion in 2025 to USD 2.82 billion by 2034, registering a CAGR of 25.92%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H8870",
    publishDate: "June, 2025",
    category: "Aerospace and Defense",
    pages: "233",
    price: "$3999",
  },

  {
    image: img,
    title: "Artificial Intelligence in Banking Market Size, Share and Trends 2025 to 2034",
    info: "The Global Artificial Intelligence in Banking Market is projected to grow from USD 35.28 billion in 2025 to approximately USD 394.26 billion by 2034, at a CAGR of 30.76%. The North America accounted for USD 11.28 billion in 2025 and is expected to expand at a CAGR of 29.83% during the forecast period. In the U.S Artificial Intelligence in Banking Market, the market is expected to increase from USD 10.38 billion in 2025 to USD 106.45 billion by 2034, registering a CAGR of 29.51%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6687",
    publishDate: "May, 2025",
    category: "BFSI",
    pages: "236",
    price: "$3999",
  },

  {
    image: img,
    title: "Enterprise Artificial Intelligence (AI) Market Size, Share and Trends 2025 to 2034",
    info: "The Global Enterprise Artificial Intelligence (AI) Market is projected to grow from USD 25.59 billion in 2025 to approximately USD 557.53 billion by 2034, at a CAGR of 40.83%. The North America accounted for USD 9.46 billion in 2025 and is expected to expand at a CAGR of 39.96% during the forecast period. In the U.S Enterprise Artificial Intelligence (AI) Market, the market is expected to increase from USD 8.80 billion in 2025 to USD 177.57 billion by 2034, registering a CAGR of 39.62%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H8513",
    publishDate: "April, 2025",
    category: "BFSI",
    pages: "250",
    price: "$3999",
  },

  {
    image: img,
    title: "Robotics Process Automation (RPA) Market Size, Share and Trends 2025 to 2034",
    info: "The Global Robotics Process Automation (RPA) market is projected to grow from USD 28.03 billion in 2025 to approximately USD 208.95 billion by 2034, at a CAGR of 25.01%. The North America accounted for USD 10.90 billion in 2025 and is expected to expand at a CAGR of 24.65% during the forecast period. In the U.S Robotics Process Automation (RPA) market, the market is expected to increase from USD 10.36 billion in 2025 to USD 73.68 billion by 2034, registering a CAGR of 24.35%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6273",
    publishDate: "June, 2025",
    category: "BFSI",
    pages: "247",
    price: "$3999",
  },

  {
    image: img,
    title: "Digital Transformation Market Size, Share and Trends 2025 to 2034",
    info: "The Global Digital Transformation market is projected to grow from USD 1432.69 billion in 2025 to approximately USD 11683 billion by 2034, at a CAGR of 26.26%. The North America accounted for USD 630.38 billion in 2025 and is expected to expand at a CAGR of 25.61% during the forecast period. In the US Digital Transformation market, the market is expected to increase from USD 598.86 billion in 2025 to USD 4563.48 billion by 2034, registering a CAGR of 25.31%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H8723",
    publishDate: "May, 2025",
    category: "BFSI",
    pages: "250",
    price: "$3999",
  },

  {
    image: img,
    title: "Debt Settlement Market Size, Share and Trends 2025 to 2034",
    info: "The Global Debt Settlement Market is projected to grow from USD 10.36 billion in 2025 to approximately USD 18.10 billion by 2034, at a CAGR of 6.40%. The North America accounted for USD 3.62 billion in 2025 and is expected to expand at a CAGR of 5.70% during the forecast period. In the U.S Debt Settlement Market, the market is expected to increase from USD 3.33 billion in 2025 to USD 5.37 billion by 2034, registering a CAGR of 5.44%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H9493",
    publishDate: "June, 2025",
    category: "BFSI",
    pages: "232",
    price: "$3999",
  },

  {
    image: img,
    title: "Consumer Robotics Market Size, Share and Trends 2025 to 2034",
    info: "The Global Consumer Robotics Market is projected to grow from USD 13.67 billion in 2025 to approximately USD 100.14 billion by 2034, at a CAGR of 24.77%. The North America accounted for USD 4.92 billion in 2025 and is expected to expand at a CAGR of 23.98% during the forecast period. In the U.S Consumer Robotics Market, the market is expected to increase from USD 4.47 billion in 2025 to USD 30.30 billion by 2034, registering a CAGR of 23.67%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1043",
    publishDate: "July, 2025",
    category: "Automotive and Transportation",
    pages: "240",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Insurance Third Party Administration Market Size, Share and Trends 2025 to 2034",
    info: "The Global Insurance Third Party Administration Market is projected to grow from USD 409.26 billion in 2025 to approximately USD 822.88 billion by 2034, at a CAGR of 8.07%. The North America accounted for USD 175.98 billion in 2025 and is expected to expand at a CAGR of 7.50% during the forecast period. In the U.S Insurance Third Party Administration Market is expected to increase from USD 160.14 billion in 2025 to USD 300.26 billion by 2034, registering a CAGR of 7.23%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H2249",
    publishDate: "June, 2025",
    category: "ICT and Media",
    pages: "228",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Butter Packaging Market Size, Share and Trends 2025 to 2034",
    info: "The Global Butter Packaging Market is projected to grow from USD 145.74 billion in 2025 to approximately USD 229.01 billion by 2034, at a CAGR of 5.15%. The Europe accounted for USD 51.0 billion in 2025 and is expected to expand at a CAGR of 4.46% during the forecast period. In the Germany Butter Packaging Market, the market is expected to increase from USD 47.43 billion in 2025 to USD 68.72 billion by 2034, registering a CAGR of 4.21%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H3345",
    publishDate: "May, 2025",
    category: "Food and Beverages",
    pages: "210",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Fermented Foods Market Size, Share and Trends 2025 to 2034",
    info: "The Global Fermented Foods Market is projected to grow from USD 261.56 billion in 2025 to approximately USD 398.86 billion by 2034, at a CAGR of 4.80%. Asia Pacific accounted for USD 109.85 billion in 2025 and is set to expand at a CAGR of 4.23% during the forecast period. In the China Fermented Foods Market, the market is expected to increase from USD 101.06 billion in 2025 to USD 143.58 billion by 2034, registering a CAGR of 3.98%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H4021",
    publishDate: "April, 2025",
    category: "Food and Beverages",
    pages: "230",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Food Cans Market Size, Share and Trends 2025 to 2034",
    info: "The Global Food Cans Market is projected to grow from USD 19.61 billion in 2025 to approximately USD 25.30 billion by 2034, at a CAGR of 2.87%. The North America accounted for USD 6.27 billion in 2025 and is expected to expand at a CAGR of 2.14% during the forecast period. In the U.S Food Cans Market is expected to increase from USD 5.77 billion in 2025 to USD 6.83 billion by 2034, registering a CAGR of 1.89%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H5178",
    publishDate: "July, 2025",
    category: "Food and Beverages",
    pages: "214",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Engine Bush Market Size, Share and Trends 2025 to 2034",
    info: "The Global Engine Bush Market is projected to grow from USD 3.85 billion in 2025 to approximately USD 5.13 billion by 2034, at a CAGR of 3.24%. Asia Pacific accounted for USD 1.73 billion in 2025 and is set to expand at a CAGR of 2.72% during the forecast period. In the China Engine Bush Market, the market is expected to increase from USD 1.62 billion in 2025 to USD 2.02 billion by 2034, registering a CAGR of 2.48%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6230",
    publishDate: "May, 2025",
    category: "Automotive and Transportation",
    pages: "202",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Automotive Sunroof Motor Market Size, Share and Trends 2025 to 2034",
    info: "The Global Automotive Sunroof Motor Market is projected to grow from USD 15.14 billion in 2025 to approximately USD 28.18 billion by 2034, at a CAGR of 7.15%. Asia Pacific accounted for USD 6.66 billion in 2025 and is set to expand at a CAGR of 6.59% during the forecast period. In the China Automotive Sunroof Motor Market, the market is expected to increase from USD 6.26 billion in 2025 to USD 10.88 billion by 2034, registering a CAGR of 6.34%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H7019",
    publishDate: "June, 2025",
    category: "Automotive and Transportation",
    pages: "218",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Motorcycle Airbag Market Size, Share and Trends 2025 to 2034",
    info: "The Global Motorcycle Airbag Market is projected to grow from USD 0.71 billion in 2025 to approximately USD 2.06 billion by 2034, at a CAGR of 12.56%. The North America accounted for USD 0.23 billion in 2025 and is expected to expand at a CAGR of 11.79% during the forecast period. In the U.S Motorcycle Airbag Market is expected to increase from USD 0.21 billion in 2025 to USD 0.57 billion by 2034, registering a CAGR of 11.51%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H8095",
    publishDate: "April, 2025",
    category: "Automotive and Transportation",
    pages: "205",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Smart Key Market Size, Share and Trends 2025 to 2034",
    info: "The Global Smart Key Market is projected to grow from USD 4.58 billion in 2025 to approximately USD 11.27 billion by 2034, at a CAGR of 10.52%. The North America accounted for USD 1.37 billion in 2025 and is expected to expand at a CAGR of 9.68% during the forecast period. In the U.S Smart Key Market is expected to increase from USD 1.27 billion in 2025 to USD 2.87 billion by 2034, registering a CAGR of 9.41%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H9140",
    publishDate: "July, 2025",
    category: "Automotive and Transportation",
    pages: "222",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Baby Car Seat Market Size, Share and Trends 2025 to 2034",
    info: "The Global Baby Car Seat Market is projected to grow from USD 10.97 billion in 2025 to approximately USD 18.55 billion by 2034, at a CAGR of 6.01%. The Europe accounted for USD 3.72 billion in 2025 and is expected to expand at a CAGR of 5.30% during the forecast period. In the Germany Baby Car Seat Market, the market is expected to increase from USD 3.54 billion in 2025 to USD 5.52 billion by 2034, registering a CAGR of 5.05%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H1008",
    publishDate: "June, 2025",
    category: "Automotive and Transportation",
    pages: "215",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Automotive Sun Visor Market Size, Share and Trends 2025 to 2034",
    info: "The Global Automotive Sun Visor Market is projected to grow from USD 2.59 billion in 2025 to approximately USD 3.92 billion by 2034, at a CAGR of 4.71%. The North America accounted for USD 1.06 billion in 2025 and is expected to expand at a CAGR of 4.13% during the forecast period. In the U.S Automotive Sun Visor Market is expected to increase from USD 0.98 billion in 2025 to USD 1.39 billion by 2034, registering a CAGR of 3.88%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H2084",
    publishDate: "April, 2025",
    category: "Automotive and Transportation",
    pages: "203",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Electric SUV Market Size, Share and Trends 2025 to 2034",
    info: "The Global Electric SUV Market is projected to grow from USD 974.98 billion in 2025 to approximately USD 12537.97 billion by 2034, at a CAGR of 32.82%. The Europe accounted for USD 448.49 billion in 2025 and is expected to expand at a CAGR of 32.16% during the forecast period. In the Germany Electric SUV Market, the market is expected to increase from USD 426.06 billion in 2025 to USD 5130.53 billion by 2034, registering a CAGR of 31.85%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H3117",
    publishDate: "May, 2025",
    category: "Automotive and Transportation",
    pages: "260",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Luxury Car Market Size, Share and Trends 2025 to 2034",
    info: "The Global Luxury Car Market is projected to grow from USD 747.29 billion in 2025 to approximately USD 1379.48 billion by 2034, at a CAGR of 7.05%. The Europe accounted for USD 298.91 billion in 2025 and is expected to expand at a CAGR of 6.44% during the forecast period. In the Germany Luxury Car Market, the market is expected to increase from USD 280.98 billion in 2025 to USD 492.75 billion by 2034, registering a CAGR of 6.44%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H4562",
    publishDate: "July, 2025",
    category: "Automotive and Transportation",
    pages: "248",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Fish Pumps Market Size, Share and Trends 2025 to 2034",
    info: "The Global Fish Pumps Market is projected to grow from USD 150.12 billion in 2025 to approximately USD 288.34 billion by 2034, at a CAGR of 7.52%. The Europe accounted for USD 49.53 billion in 2025 and is expected to expand at a CAGR of 6.78% during the forecast period. In the Germany Fish Pumps Market, the market is expected to increase from USD 45.08 billion in 2025 to USD 79.53 billion by 2034, registering a CAGR of 6.51%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H5239",
    publishDate: "June, 2025",
    category: "Consumer Goods",
    pages: "219",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Soil Remediation Market Size, Share and Trends 2025 to 2034",
    info: "The Global Soil Remediation Market is projected to grow from USD 48.78 billion in 2025 to approximately USD 88.87 billion by 2034, at a CAGR of 6.89%. Asia Pacific accounted for USD 17.0 billion in 2025 and is set to expand at a CAGR of 6.19% during the forecast period. In the China Soil Remediation Market, the market is expected to increase from USD 15.64 billion in 2025 to USD 26.29 billion by 2034, registering a CAGR of 5.93%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H6020",
    publishDate: "May, 2025",
    category: "Materials and Chemicals",
    pages: "232",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Soil Monitoring Market Size, Share and Trends 2025 to 2034",
    info: "The Global Soil Monitoring Market is projected to grow from USD 890.77 million in 2025 to approximately USD 3269.16 million by 2034, at a CAGR of 15.54%. The North America accounted for USD 329.58 million in 2025 and is expected to expand at a CAGR of 14.83% during the forecast period. In the U.S Soil Monitoring Market is expected to increase from USD 303.21 million in 2025 to USD 1029.78 million by 2034, registering a CAGR of 14.55%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H7114",
    publishDate: "April, 2025",
    category: "Semiconductor and Electronics",
    pages: "206",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Aquaponics Market Size, Share and Trends 2025 to 2034",
    info: "The Global Aquaponics Market is projected to grow from USD 1.22 billion in 2025 to approximately USD 2.78 billion by 2034, at a CAGR of 9.58%. The North America accounted for USD 0.37 billion in 2025 and is expected to expand at a CAGR of 8.77% during the forecast period. In the U.S Aquaponics Market is expected to increase from USD 0.34 billion in 2025 to USD 0.72 billion by 2034, registering a CAGR of 8.51%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H8143",
    publishDate: "July, 2025",
    category: "Food and Beverages",
    pages: "211",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Bioherbicides Market Size, Share and Trends 2025 to 2034",
    info: "The Global Bioherbicides Market is projected to grow from USD 3.91 billion in 2025 to approximately USD 14.06 billion by 2034, at a CAGR of 15.28%. The North America accounted for USD 1.13 billion in 2025 and is expected to expand at a CAGR of 14.37% during the forecast period. In the U.S Bioherbicides Market is expected to increase from USD 1.03 billion in 2025 to USD 3.37 billion by 2034, registering a CAGR of 14.09%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H9227",
    publishDate: "June, 2025",
    category: "Materials and Chemicals",
    pages: "225",
    price: "$3999",
  },

  {
    image: img,
    title: "Hydroponics Market Size, Share and Trends 2025 to 2034",
    info: "The Global Hydroponics Market is projected to grow from USD 6.28 billion in 2025 to approximately USD 17.94 billion by 2034, at a CAGR of 12.37%. Asia Pacific accounted for USD 2.26 billion in 2025 and is set to expand at a CAGR of 11.66% during the forecast period. In the China Hydroponics Market, the market is expected to increase from USD 2.10 billion in 2025 to USD 5.55 billion by 2034, registering a CAGR of 11.39%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "H9423",
    publishDate: "May, 2025",
    category: "Food and Beverages",
    pages: "243",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Rice Seed Market Size, Share and Trends 2025 to 2034",
    info: "The Global Rice Seed Market is projected to grow from USD 7.95 billion in 2025 to approximately USD 11.05 billion by 2034, at a CAGR of 3.73%. Asia Pacific accounted for USD 6.12 billion in 2025 and is set to expand at a CAGR of 3.42% during the forecast period. In the China Rice Seed Market, the market is expected to increase from USD 5.50 billion in 2025 to USD 7.29 billion by 2034, registering a CAGR of 3.17%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "A8021",
    publishDate: "July, 2025",
    category: "Food and Beverages",
    pages: "238",
    price: "$3999",
  },

  {
    image: img,
    title: "Agricultural Pumps Market Size, Share and Trends 2025 to 2034",
    info: "The Global Agricultural Pumps Market is projected to grow from USD 15.35 billion in 2025 to approximately USD 23.91 billion by 2034, at a CAGR of 5.05%. Asia Pacific accounted for USD 5.83 billion in 2025 and is set to expand at a CAGR of 4.42% during the forecast period. In the China Agricultural Pumps Market, the market is expected to increase from USD 5.24 billion in 2025 to USD 7.57 billion by 2034, registering a CAGR of 4.16%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "C1092",
    publishDate: "July, 2025",
    category: "Construction and Manufacturing",
    pages: "236",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Packaged Water Treatment Market Size, Share and Trends 2025 to 2034",
    info: "The Global Packaged Water Treatment Market is projected to grow from USD 32.73 billion in 2025 to approximately USD 73.42 billion by 2034, at a CAGR of 9.39%. Asia Pacific accounted for USD 15.38 billion in 2025 and is set to expand at a CAGR of 8.86% during the forecast period. In the China Packaged Water Treatment Market, the market is expected to increase from USD 13.99 billion in 2025 to USD 29.40 billion by 2034, registering a CAGR of 8.60%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "M8740",
    publishDate: "June, 2025",
    category: "Materials and Chemicals",
    pages: "240",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Automatic Labeling Machine Market Size, Share and Trends 2025 to 2034",
    info: "The Global Automatic Labeling Machine Market is projected to grow from USD 3.38 billion in 2025 to approximately USD 4.79 billion by 2034, at a CAGR of 3.95%. Asia Pacific accounted for USD 1.38 billion in 2025 and is set to expand at a CAGR of 3.37% during the forecast period. In the China Automatic Labeling Machine Market, the market is expected to increase from USD 1.30 billion in 2025 to USD 1.71 billion by 2034, registering a CAGR of 3.13%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "C5411",
    publishDate: "July, 2025",
    category: "Construction and Manufacturing",
    pages: "228",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Broaching Machine Market Size, Share and Trends 2025 to 2034",
    info: "The Global Broaching Machine Market is projected to grow from USD 1.72 billion in 2025 to approximately USD 2.50 billion by 2034, at a CAGR of 4.24%. Asia Pacific accounted for USD 0.60 billion in 2025 and is set to expand at a CAGR of 3.56% during the forecast period. In the China Broaching Machine Market, the market is expected to increase from USD 0.55 billion in 2025 to USD 0.74 billion by 2034, registering a CAGR of 3.31%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "C7754",
    publishDate: "May, 2025",
    category: "Construction and Manufacturing",
    pages: "239",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Wrapping Machine Market Size, Share and Trends 2025 to 2034",
    info: "The Global Wrapping Machine Market is projected to grow from USD 2.85 billion in 2025 to approximately USD 4.78 billion by 2034, at a CAGR of 5.91%. Asia Pacific accounted for USD 1.11 billion in 2025 and is set to expand at a CAGR of 5.30% during the forecast period. In the China Wrapping Machine Market, the market is expected to increase from USD 1.02 billion in 2025 to USD 1.59 billion by 2034, registering a CAGR of 5.04%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "C9431",
    publishDate: "June, 2025",
    category: "Construction and Manufacturing",
    pages: "244",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Heat-Shrink Tubing Market Size, Share and Trends 2025 to 2034",
    info: "The Global Heat-Shrink Tubing Market is projected to grow from USD 3.03 billion in 2025 to approximately USD 5.07 billion by 2034, at a CAGR of 5.89%. The North America accounted for USD 1.09 billion in 2025 and is expected to expand at a CAGR of 5.22% during the forecast period. In the U.S Heat-Shrink Tubing Market, the market is expected to increase from USD 0.99 billion in 2025 to USD 1.53 billion by 2034, registering a CAGR of 4.96%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "E3109",
    publishDate: "July, 2025",
    category: "Energy and Power",
    pages: "237",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Alkaline Water Electrolysis Market Size, Share and Trends 2025 to 2034",
    info: "The Global Alkaline Water Electrolysis Market is projected to grow from USD 0.22 billion in 2025 to approximately USD 1.08 billion by 2034, at a CAGR of 19.34%. The Europe accounted for USD 0.088 billion in 2025 and is expected to expand at a CAGR of 18.66% during the forecast period. In the Germany Alkaline Water Electrolysis Market, the market is expected to increase from USD 0.080 billion in 2025 to USD 0.369 billion by 2034, registering a CAGR of 18.37%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "E8210",
    publishDate: "May, 2025",
    category: "Energy and Power",
    pages: "245",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Hydrogen Market Size, Share and Trends 2025 to 2034",
    info: "The Global Hydrogen Market is projected to grow from USD 243.19 billion in 2025 to approximately USD 503.11 billion by 2034, at a CAGR of 8.41%. Asia Pacific accounted for USD 87.54 billion in 2025 and is set to expand at a CAGR of 7.73% during the forecast period. In the China Hydrogen Market, the market is expected to increase from USD 82.29 billion in 2025 to USD 157.37 billion by 2034, registering a CAGR of 7.47%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "E7014",
    publishDate: "June, 2025",
    category: "Energy and Power",
    pages: "246",
    price: "$3999",
  },
  
  {
    image: img,
    title: "AI in Energy Market Size, Share and Trends 2025 to 2034",
    info: "The Global AI in Energy Market is projected to grow from USD 15.68 billion in 2025 to approximately USD 89.86 billion by 2034, at a CAGR of 21.41%. Asia Pacific accounted for USD 6.42 billion in 2025 and is set to expand at a CAGR of 20.74% during the forecast period. In the China AI in Energy Market, the market is expected to increase from USD 6.04 billion in 2025 to USD 32.24 billion by 2034, registering a CAGR of 20.45%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "E9407",
    publishDate: "July, 2025",
    category: "Energy and Power",
    pages: "250",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Earthquake Insurance Market Size, Share and Trends 2025 to 2034",
    info: "The Global Earthquake Insurance Market is projected to grow from USD 8.54 billion in 2025 to approximately USD 15.97 billion by 2034, at a CAGR of 7.20%. The North America accounted for USD 3.33 billion in 2025 and is expected to expand at a CAGR of 6.58% during the forecast period. In the U.S Earthquake Insurance Market, the market is expected to increase from USD 3.09 billion in 2025 to USD 5.37 billion by 2034, registering a CAGR of 6.32%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "C7913",
    publishDate: "May, 2025",
    category: "Consumer Goods",
    pages: "232",
    price: "$3999",
  },

  {
    image: img,
    title: "Mushroom Coffee Market Size, Share and Trends 2025 to 2034",
    info: "Mushroom Coffee Market is projected to grow from USD 3.21 billion in 2025 to approximately USD 5.20 billion by 2034, at a CAGR of 5.51%. The North America accounted for USD 0.93 billion in 2025 and is expected to expand at a CAGR of 4.67% during the forecast period. In the U.S Mushroom Coffee Market, the market is expected to increase from USD 0.87 billion in 2025 to USD 1.29 billion by 2034, registering a CAGR of 4.42%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "C8932",
    publishDate: "July, 2025",
    category: "Consumer Goods",
    pages: "238",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Stone Crushing Equipment Market Size, Share and Trends 2025 to 2034",
    info: "Stone Crushing Equipment Market is projected to grow from USD 8.11 billion in 2025 to approximately USD 89.86 billion by 2034, at a CAGR of 14.61%. Asia Pacific accounted for USD 3.08 billion in 2025 and is set to expand at a CAGR of 6.12% during the forecast period. In the China Stone Crushing Equipment Market, the market is expected to increase from USD 2.83 billion in 2025 to USD 4.73 billion by 2034, registering a CAGR of 5.86%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "C9721",
    publishDate: "June, 2025",
    category: "Consumer Goods",
    pages: "246",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Agarwood Chips Market Size, Share and Trends 2025 to 2034",
    info: "Agarwood Chips Market is projected to grow from USD 44.19 billion in 2025 to approximately USD 84.27 billion by 2034, at a CAGR of 7.44%. The North America accounted for USD 17.67 billion in 2025 and is expected to expand at a CAGR of 6.83% during the forecast period. In the U.S Agarwood Chips Market, the market is expected to increase from USD 16.26 billion in 2025 to USD 28.82 billion by 2034, registering a CAGR of 6.56%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "C7114",
    publishDate: "July, 2025",
    category: "Consumer Goods",
    pages: "242",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Rare Earth Minerals Market Size, Share and Trends 2025 to 2034",
    info: "Rare Earth Minerals Market is projected to grow from USD 4.33 billion in 2025 to approximately USD 8.82 billion by 2034, at a CAGR of 8.23%. Asia Pacific accounted for USD 3.72 billion in 2025 and is set to expand at a CAGR of 7.94% during the forecast period. In the China Rare Earth Minerals Market, the market is expected to increase from USD 3.35 billion in 2025 to USD 6.51 billion by 2034, registering a CAGR of 7.67%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "M7806",
    publishDate: "May, 2025",
    category: "Materials and Chemicals",
    pages: "239",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Silicon Nitride Market Size, Share and Trends 2025 to 2034",
    info: "Silicon Nitride Market is projected to grow from USD 59.27 billion in 2025 to approximately USD 121.31 billion by 2034, at a CAGR of 8.28%. The North America accounted for USD 26.07 billion in 2025 and is expected to expand at a CAGR of 7.73% during the forecast period. In the U.S Silicon Nitride Market, the market is expected to increase from USD 23.47 billion in 2025 to USD 44.83 billion by 2034, registering a CAGR of 7.46%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "M9923",
    publishDate: "June, 2025",
    category: "Materials and Chemicals",
    pages: "247",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Water Recycle and Reuse Market Size, Share and Trends 2025 to 2034",
    info: "Water Recycle and Reuse Market is projected to grow from USD 19.29 billion in 2025 to approximately USD 44.43 billion by 2034, at a CAGR of 9.71%. Asia Pacific accounted for USD 7.13 billion in 2025 and is set to expand at a CAGR of 9.04% during the forecast period. In the China Water Recycle and Reuse Market, the market is expected to increase from USD 6.42 billion in 2025 to USD 13.68 billion by 2034, registering a CAGR of 8.77%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "M5110",
    publishDate: "July, 2025",
    category: "Materials and Chemicals",
    pages: "248",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Metal Closures Market Size, Share and Trends 2025 to 2034",
    info: "Metal Closures Market is projected to grow from USD 29.15 billion in 2025 to approximately USD 48.83 billion by 2034, at a CAGR of 5.90%. Asia Pacific accounted for USD 10.20 billion in 2025 and is set to expand at a CAGR of 5.21% during the forecast period. In the China Metal Closures Market, the market is expected to increase from USD 9.48 billion in 2025 to USD 14.66 billion by 2034, registering a CAGR of 4.96%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "M6114",
    publishDate: "May, 2025",
    category: "Materials and Chemicals",
    pages: "234",
    price: "$3999",
  },
  
  {
    image: img,
    title: "White Oil Market Size, Share and Trends 2025 to 2034",
    info: "White Oil Market is projected to grow from USD 2.31 billion in 2025 to approximately USD 3.49 billion by 2034, at a CAGR of 4.69%. Asia Pacific accounted for USD 1.13 billion in 2025 and is set to expand at a CAGR of 4.21% during the forecast period. In the China White Oil Market, the market is expected to increase from USD 1.05 billion in 2025 to USD 1.49 billion by 2034, registering a CAGR of 3.96%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "M4015",
    publishDate: "June, 2025",
    category: "Materials and Chemicals",
    pages: "230",
    price: "$3999",
  },
  
  {
    image: img,
    title: "Veterinary Antihistamines Market Size, Share and Trends 2025 to 2034",
    info: "Veterinary Antihistamines Market is projected to grow from USD 1.35 billion in 2025 to approximately USD 2.16 billion by 2034, at a CAGR of 5.36%. The North America accounted for USD 0.51 billion in 2025 and is expected to expand at a CAGR of 4.73% during the forecast period. In the U.S Veterinary Antihistamines Market, the market is expected to increase from USD 0.47 billion in 2025 to USD 0.69 billion by 2034, registering a CAGR of 4.47%. All figures are revenue-based (USD Million/Billion), with 2024 as the base year.",
    reportCode: "L5409",
    publishDate: "July, 2025",
    category: "Life Sciences",
    pages: "233",
    price: "$3999",
  }

];

export default reportsData;
